import React from "react";
import { UniqueSellingPointsBig, IconType } from "@carfax/web-ui/components/UniqueSellingPointsBig";
import { UniqueSellingPointsSmall } from "@carfax/web-ui/components/UniqueSellingPointsSmall";
import { ModuleUsps } from "@carfax/contentful/PageModularModule";

interface Props {
  module: ModuleUsps;
}

const Usps: React.FC<Props> = ({ module: { ...props } }) => {
  if (props.type === IconType.SMALL) {
    return <UniqueSellingPointsSmall {...props} />;
  }
  return <UniqueSellingPointsBig {...props} />;
};

export default Usps;
